module.exports = __webpack_public_path__ + "static/media/KCL.b805a896.jpg";